module.exports = __webpack_public_path__ + "img/search.c5789126.svg";